import { render } from "./ModalsComponents.vue?vue&type=template&id=b4c3a026"
import script from "./ModalsComponents.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ModalsComponents.vue?vue&type=script&charset=utf-8&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__